import { Box, makeStyles, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FieldErrors } from 'react-hook-form/dist/types/form';
import { useTranslation } from 'react-i18next';

interface OwnProps {
  label?: string;
  name?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  defaultValue?: string | number | undefined | null;
  type?: string;
  errors?: FieldErrors;
  value?: string | number | undefined | null;
  mandatory?: boolean;
  isDenseLabel?: boolean;
  id?: string;
  multiline?: boolean;
  refReg?: any;
  focus?: boolean;
  onChange?: (value: string) => void;
  onKeyPress?: (value: any) => void;
  rows?: string | number;
}

export default function InputField({
  id,
  label,
  name = '',
  placeholder,
  disabled = false,
  required = false,
  errors = [],
  value = '',
  mandatory = false,
  defaultValue,
  type = 'text',
  multiline = false,
  refReg = undefined,
  focus = false,
  onChange,
  onKeyPress,
  rows = 1,
  ...rest
}: OwnProps) {
  const [state, setState] = useState(value);
  const classes = useStyles();
  const { t } = useTranslation();
  const isError = !!errors[name];

  useEffect(() => {
    setState((oldState) => (oldState !== value ? value : oldState));
  }, [value, setState]);

  return (
    <>
      <TextField
        {...rest}
        id={id}
        type={type}
        name={name}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setState(event.target.value);
        }}
        onKeyPress={(event) => (onKeyPress ? onKeyPress(event) : null)}
        onBlur={(event: any) => (onChange ? onChange(event.target.value) : null)}
        label={mandatory ? `${label} *` : label}
        placeholder={placeholder}
        defaultValue={defaultValue}
        disabled={disabled}
        required={required}
        value={refReg ? undefined : state}
        variant="outlined"
        multiline={multiline}
        margin="normal"
        fullWidth
        error={isError}
        inputRef={refReg}
        autoFocus={focus}
        rows={rows}
      />
      <Box className={classes.ErrorBox}>
        <Typography variant="caption">{t(errors[name]?.message)}</Typography>
      </Box>
    </>
  );
}

const useStyles = makeStyles(() => ({
  ErrorBox: {
    color: 'red',
  },
}));
